import { render, staticRenderFns } from "./InstallationsDataTable.vue?vue&type=template&id=465ad630&"
import script from "./InstallationsDataTable.vue?vue&type=script&lang=js&"
export * from "./InstallationsDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports